export default __webpack_public_path__ + "assets/guinea-flag.png";